import { useSelector } from 'react-redux';
import { formatSetupBrokerlabel } from '../helpers/data-manipulators';
import { getIsBrokers } from '../reducers';

function useBrokerDataAll() {
  const brokersData = useSelector(getIsBrokers);

  const brokersDataAllFilterd = brokersData.map((b) => ({
    label: formatSetupBrokerlabel(b),
    value: b.id,
    brokerDisabled: b.status && b.status === 'disabled' ? true : false,
  }));

  return brokersDataAllFilterd;
}

export default useBrokerDataAll;
